import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Header.css';


export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [coinCount, setCoinCount] = useState(() => parseInt(localStorage.getItem('coins')) || 0);
  const { user } = useAuth();
  const location = useLocation();

  /* Sync coin count from localStorage (updated by puzzle page) */
  useEffect(() => {
    const handleStorage = () => setCoinCount(parseInt(localStorage.getItem('coins')) || 0);
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const handleLogout = async () => {
  try {
    await signOut(auth);
    // Optionally navigate or show a success message
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

useEffect(() => {
  console.log('Current User:', user);
}, [user]);

  return (
    <header className="app-header">
      <div className="header-content">

        {/* Coin Display */}
        <div className="coin-wrap">
          <span className="coin-icon" role="img" aria-label="Coins">💰</span>
          <span className="coin-count">{coinCount}</span>
        </div>

        {/* Brand Stack */}
        <div className="brand-stack">
          <div>That</div>
          <div>Puzzle</div>
          <div>App.com</div>
        </div>

        {/* Hamburger Menu */}
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          ☰
        </button>

        {/* Main Navigation */}
        <nav
          className={`nav-links ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(false)}
        >
          <Link to="/">Home</Link>
          <Link to="/DailyPuzzle">Daily Puzzle</Link>
          <Link to="/thedailywordpuzzle">Daily Word</Link>
          <Link to="/benefits">Benefits</Link>
        </nav>

        {/* Auth Button - floats right */}
        <div className="auth-control">
          {user ? (
            <button className="auth-btn" onClick={handleLogout}>Logout</button>
          ) : (
            location.pathname !== '/login' && (
              <Link className="auth-btn" to="/login">Login</Link>
            )
          )}
        </div>
      </div>
    </header>
  );
}
